import Big from "big.js"

export default {
    calculate(lineSize, waitingPeriodInterest) {
        return new Big(waitingPeriodInterest).plus(lineSize).toFixed(2);
    }
}

